<!-- Single Article Builder -->

<template>
	<div class="main">
		<div class="title wi8_font">Single Article Builder</div>

		<ArtDetail />

	</div>
</template>

<script>
export default {

}
</script>

<style scoped>
	.main {
		height: 100%;
		background-color: #FCFCEE;
		padding: 5px;
		border: solid 0px #009;
	}
	.title {
		color: #009;
	}
</style>
